export default {
    getLatestList: {
        url: '/mps/activity/getLatestList',
        method: 'get'
    },
    getLatestTopActivityList: {
        url: '/mps/activity/getLatestActivityList',
        method: 'get'
    },
    getActivityDetail: {
        url: '/mps/activity/detail',
        method: 'get'
    },
    getActivitySpellDetail: {
        url: '/mps/activityspell/detail',
        method: 'get'
    },
    getActivitySpellGroupList: {
        url: '/mps/activityspellgroup/getSpellGroupListByActId',
        method: 'get'
    },
    getActivityPublishList: {
        url: '/mps/activity/getActivityPublishList',
        method: 'get'
    },
    getActivityOtherPublishList: {
        url: '/mps/activity/getActivityOtherPublishList',
        method: 'get'
    },
    getActivityListByPublishId: {
        url: '/mps/activity/getActivityListByPublishId',
        method: 'get'
    },
    saveActivityView: {
        url: '/mps/activity/saveActivityView',
        method: 'get'
    },
    getPackagePicSettingDetail: {
        url: '/mps/activity/getPackagePicSettingDetail',
        method: 'get'
    },
    getSpellPicSettingDetail: {
        url: '/mps/activity/getSpellPicSettingDetail',
        method: 'get'
    }
}
